import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Image = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M10 7.5C10.5523 7.5 11 7.05228 11 6.5C11 5.94772 10.5523 5.5 10 5.5C9.44771 5.5 9 5.94772 9 6.5C9 7.05228 9.44771 7.5 10 7.5Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M13.5 13H2.5C1.67157 13 1 12.3284 1 11.5V4.5C1 3.67157 1.67157 3 2.5 3H13.5C14.3284 3 15 3.67157 15 4.5V11.5C15 12.3284 14.3284 13 13.5 13ZM13.5 11.5H11.5607L11.0608 11L13.5 8.56077V11.5ZM13.5 6.43945L10.0001 9.93936L6.00006 5.93933L2.5 9.43939V4.5L13.5 4.5V6.43945ZM6.00006 8.06065L9.43941 11.5H2.56071L6.00006 8.06065Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Image;
